<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb-center">
        <span>Change Mail Status <span v-if="!isDetail&&statusIdArr.length>0">({{statusIdArr.length}})</span></span>
        <i
          class="el-icon-close"
          @click="handleCancel"></i>
      </div>
      <div class="dialog-body">
        <div
          v-if="isDetail&&!changeStatus"
          class="table table_no_title">
          <div class="tr">
            <span>Mail Status</span>
            <span>{{form.send_notice_stts_language}}</span>
          </div>
          <div class="tr">
            <span>Sent Date</span>
            <span>{{form.send_notice_date||'-'}}</span>
          </div>
          <div class="tr">
            <span>Handler</span>
            <span>{{form.handler_nm||'-'}}</span>
          </div>
          <div class="tr">
            <span>Remarks</span>
            <span>{{form.change_mail_remark||'-'}}</span>
          </div>
          <div class="tr">
            <span>Renewal Notice</span>
            <span
              v-if="form.notice_url"
              class="color-blue pointer"
              @click="openUrl(form.notice_url)">Download</span>
            <span v-else>-</span>
          </div>
        </div>
        <template v-if="changeStatus||!isDetail">
          <el-form
            ref="form"
            :rules="rules"
            :model="formData">
            <div class="form-item">
              <span class="mg-b-10">Mail Status</span>
              <el-form-item
                ref="stts"
                prop="stts"
                :rules="rules.select"
              >
                <v-radio-group
                  v-model="formData.stts"
                  block
                  :disabled="isSent"
                  :list="globalOptions.renew_mail_status"
                >
                  <template #default="{ item }">
                    <span>
                      <span
                        class="fs-12"
                        :class="{
                          'pending_verify-color': item.id ==1,
                          'color-dark': item.id == 4,
                          'verified-color': item.id == 3,
                          'purple': item.id == 2,
                        }">{{ item['name'] }}</span>
                    </span>
                  </template>
                </v-radio-group>
              </el-form-item>
            </div>

            <div class="flex-sb-center">
              <div
                v-if="formData.stts==3"
                class="form-item mg-r-20">
                <span>Sent Date</span>
                <el-form-item
                  ref="send_notice_date"
                  prop="send_notice_date"
                  :rules="rules.select">
                  <v-date-picker
                    v-model="formData.send_notice_date"
                    :disabled="isSent"
                  />
                </el-form-item>
              </div>
              <div
                :class="{'w-fill':formData.stts!=3}"
                class="form-item">
                <span>Handler </span>
                <el-form-item
                  ref="cs_id"
                  prop="cs_id"
                  :rules="rules.select"
                >
                  <v-select
                    v-model="formData.cs_id"
                    :disabled="isSent"
                    :list="assigneeList"
                  />
                </el-form-item>
              </div>
            </div>
            <div
              class="form-item">
              <span>Remarks</span>
              <el-form-item
                ref="remark"
                prop="remark"
              >
                <v-input
                  v-model="formData.remark"
                  class="mg-b-15"
                  :disabled="isSent"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </el-form>
        </template>
      </div>
      <div class="dialog-footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <template v-if="!isDetail||changeStatus">
          <v-button
            green
            @click="onContinue">Confirm</v-button>
        </template>
        <template v-if="isDetail&&!changeStatus&&form.send_notice_stts!=3">
          <v-button
            green
            @click="changeMailStatus">Change Mail Status</v-button>
        </template>
      </div>
    </div>

  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {setRenewalMailStatus} from '@api/renewal'

export default {
  name: 'new-renew-titcket-dialog',
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    isReminderDetail: {
      type: Boolean,
      default: false
    },
    value:{
      type: Boolean,
      default: false
    },
    statusIdArr:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      dialog: false,
      customerPolicyList:[],
      changeStatus:false,
      formData: {
        send_notice_date:'',
        id_arr: [],
        cs_id: '',
        remark: '',
        stts:''
      },
    }
  },
  computed:{
    isSent(){
      let {send_notice_stts} = this.form||{}
      return send_notice_stts == 3
    },
    cs_id(){
      let cs_id = localStorage.getItem('cs_id')
      return cs_id
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
        if(val) {
          if(val){
            if(this.isDetail||this.isReminderDetail){
              let {handler_id,renewal_ticket_id,change_mail_remark,send_notice_stts,id}  = this.form
              this.formData.stts = send_notice_stts
              this.formData.cs_id = handler_id||this.cs_id
              this.formData.id_arr = this.isReminderDetail?[id]:[renewal_ticket_id]
              this.formData.remark = change_mail_remark
            }
            else {
              this.formData.remark = ''
              this.formData.cs_id = ''
              this.formData.stts = ''
              this.formData.id_arr = this.statusIdArr
            }
          }
        }
      }
    },
  },
  methods: {
    changeMailStatus(){
      this.changeStatus = true
    },

    handleCancel() {
      this.$emit('input',false)
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().setRenewalMailStatus()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        setRenewalMailStatus: async id => {
          const { data } = await setRenewalMailStatus({
            ...this.formData
          })
          this.$emit('input',false)
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .table {
    //border: 1px solid #E1E4E8;
    &.table_no_title{
      .tr:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border: 1px solid #E1E4E8;
      }
    }
    .table_tr_border0{
      .tr:last-child{
        border-radius: 0!important;
      }
    }
    .th{
      padding: 16px;
      background: $gray;
      border: 1px solid #E1E4E8;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: $dark!important;
      font-weight: 600;
    }
    .tr {
      padding: 8px 16px;
      border: 1px solid #E1E4E8;
      border-top: 0;
      background: #fff!important;
      display: flex;
      align-items: center;

      /* Text/text-gray */

      color: #586069;
      &.tr-gray__title{
        background: $gray!important;
        span{
          color: #24292E!important;
        }
        .key-alt-down{
          color: #0366D6!important;
          cursor: pointer!important;
        }
      }
      span{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #586069;
        &:nth-child(2){
          color: #24292E!important;
          &.orange{
            color:  #B08800!important;
          }
          &.color-blue{
            color: #0366D6!important;
          }
          &.key-alt-down{
            color: #0366D6!important;
            cursor: pointer!important;
          }
        }
      }
      .fw-600{
        font-weight: 600;
      }
      .top-algin{
        align-self: baseline;
      }
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
      &:nth-child(2n){
        background: #fff;
      }
      &:last-child{
        //border: 0;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .width-80{
      width: 80px;
    }
    .type-button {
      // margin-right: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 20px;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;

          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
      }
    }
    /deep/ .el-date-editor{
      width: 100% !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .form-item{
    .select-type{
      display: flex;
      justify-content: space-between;
      /deep/.select-pay{
        margin-right: 30px;
        width: 50%;
      }
    }
  }
}
.mg-r-20{
  margin-right: 20px;
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
.purple{
  color: #6F42C1;

}
.w-fill{
  flex: 1;
}
</style>
